let cancelarEscuta = null;
let geracaoEscuta = 0;

function compraEmAndamento(store, path) {
  if (!path?.startsWith("/cabine/") || path === "/cabine/home") return null;
  const compra = store?.getters?.["compra/getCompra"];
  if (!compra?.id) return null;
  const totemId = store.getters["totem/getTotem"]?.id;
  if (totemId && compra.totem_id && compra.totem_id !== totemId) return null;
  return compra;
}

/** Aguarda a resposta de uma cobrança já iniciada, sem antecipar aprovação. */
export function deveAguardarResultadoPagamento(store, path) {
  const compra = compraEmAndamento(store, path);
  return (
    !!compra && compra.pago !== true && compra.etapa === "PAGAMENTO_PROCESSO"
  );
}

/** Uma compra aprovada termina sua jornada antes de aplicar manutenção. */
export function deveAdiarManutencao(store, path) {
  const compra = compraEmAndamento(store, path);
  return compra?.pago === true || deveAguardarResultadoPagamento(store, path);
}

/**
 * O snapshot de aprovação precisa chegar ao estado local antes do roteamento.
 * Conserva fotos/dados locais e a primeira aprovação, inclusive quando outro
 * snapshot ainda traz pago=false durante a escrita da etapa.
 */
export function sincronizarAprovacaoCompraLocal(store, payload, compraId) {
  const compra = store?.getters?.["compra/getCompra"];
  if (!compraId || compra?.id !== compraId || payload?.pago !== true) return;
  if (payload.id && payload.id !== compraId) return;
  if (compra.pago === true && (compra.pago_em || !payload.pago_em)) return;
  const aprovada = { ...compra, pago: true };
  if (!aprovada.pago_em && payload.pago_em) aprovada.pago_em = payload.pago_em;
  store.commit("compra/setCompra", aprovada);
}

/**
 * Encerra a escuta local da compra atual e invalida callbacks que já tenham
 * sido enfileirados pelo SDK antes do unsubscribe.
 */
export function pararEscutaCompraAtual() {
  geracaoEscuta += 1;
  const cancelar = cancelarEscuta;
  cancelarEscuta = null;

  if (typeof cancelar === "function") cancelar();
}

/**
 * Mantém uma única escuta de compra ativa. `criarEscuta` recebe o callback que
 * deve ser entregue ao SDK e devolve a função de unsubscribe.
 */
export function iniciarEscutaCompraAtual({ criarEscuta, aoAtualizar }) {
  if (typeof criarEscuta !== "function" || typeof aoAtualizar !== "function") {
    return null;
  }

  pararEscutaCompraAtual();
  const geracaoDestaEscuta = geracaoEscuta;

  const cancelar = criarEscuta((snapshot) => {
    if (geracaoDestaEscuta !== geracaoEscuta) return;
    aoAtualizar(snapshot);
  });

  // Protege também implementações de teste/adaptadores que chamem o callback
  // de forma síncrona e encerrem a sessão durante a própria criação.
  if (geracaoDestaEscuta !== geracaoEscuta) {
    if (typeof cancelar === "function") cancelar();
    return null;
  }

  cancelarEscuta = typeof cancelar === "function" ? cancelar : null;
  return cancelarEscuta;
}

/**
 * A manutenção encerra a sessão somente neste Totem. O registro remoto da
 * compra não é reclassificado como cancelado/expirado implicitamente.
 */
export function encerrarSessaoCompraParaManutencao(store) {
  pararEscutaCompraAtual();
  if (store && typeof store.commit === "function") {
    store.commit("compra/resetCompra");
  }
}
